import { render, staticRenderFns } from "./LoadingDialog.vue?vue&type=template&id=2bbe2203&"
import script from "./LoadingDialog.vue?vue&type=script&lang=js&"
export * from "./LoadingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VOverlay,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bbe2203')) {
      api.createRecord('2bbe2203', component.options)
    } else {
      api.reload('2bbe2203', component.options)
    }
    module.hot.accept("./LoadingDialog.vue?vue&type=template&id=2bbe2203&", function () {
      api.rerender('2bbe2203', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/basic/LoadingDialog.vue"
export default component.exports